import { Button } from 'antd'

import { pick } from '@eastcoal/common/utils/object'

import { FormMode } from '../../../CrudForm/enums/FormMode'
import { useCrudFormStore } from '../../../CrudForm/Store/hooks/useStore'
import { useCrudModalFormStore } from '../../Store/hooks/useStore'

import { CancelButtonProps } from './interface'

export const CancelButton = ({
  readable,
  type = 'default',
  children = '取消'
}: CancelButtonProps) => {
  const { toggleModalOpen } = useCrudModalFormStore(state =>
    pick(state, ['toggleModalOpen'])
  )
  const { mode, setMode } = useCrudFormStore(state =>
    pick(state, ['mode', 'setMode'])
  )

  const handleClick = () => {
    if (mode === FormMode.READ || mode === FormMode.CREATE) {
      toggleModalOpen()
    } else {
      if (readable) {
        setMode(FormMode.READ)
      } else {
        toggleModalOpen()
      }
    }
  }

  return (
    <Button type={type} onClick={handleClick}>
      {children}
    </Button>
  )
}
